// routes.ts
import { lazy } from 'react';

// Types for our data structures
export type SubCategory = {
    id: string;
    name: string;
    path: string;
};

export type Category = {
    id: string;
    name: string;
    icon: string;
    subCategories: SubCategory[];
    isOpen?: boolean;
};

// Define all categories and subcategories
export const categories: Category[] = [
    // {
    //     id: 'viewers',
    //     name: 'Viewers',
    //     icon: '👁️',
    //     isOpen: false,
    //     subCategories: [
            // { id: 'html-viewer', name: 'HTML Viewer', path: '/html-viewer' },
            // { id: 'css-viewer', name: 'CSS Viewer', path: '/css-viewer' },
            // { id: 'javascript-viewer', name: 'JavaScript Viewer', path: '/javascript-viewer' },
            // { id: 'json-viewer', name: 'JSON Viewer', path: '/json-viewer' },
            // { id: 'xml-viewer', name: 'XML Viewer', path: '/xml-viewer' },
            // { id: 'yaml-viewer', name: 'YAML Viewer', path: '/yaml-viewer' },
            // { id: 'markdown-viewer', name: 'Markdown Viewer', path: '/markdown-viewer' },
            // { id: 'csv-viewer', name: 'CSV Viewer', path: '/csv-viewer' },
            // { id: 'sql-viewer', name: 'SQL Viewer', path: '/sql-viewer' },
            // { id: 'php-viewer', name: 'PHP Viewer', path: '/php-viewer' },
            // { id: 'python-viewer', name: 'Python Viewer', path: '/python-viewer' },
            // { id: 'java-viewer', name: 'Java Viewer', path: '/java-viewer' },
            // { id: 'c-cpp-viewer', name: 'C/C++ Viewer', path: '/c-cpp-viewer' },
            // { id: 'go-viewer', name: 'Go Viewer', path: '/go-viewer' },
            // { id: 'rust-viewer', name: 'Rust Viewer', path: '/rust-viewer' },
            // { id: 'typescript-viewer', name: 'TypeScript Viewer', path: '/typescript-viewer' },
            // { id: 'react-viewer', name: 'React Viewer', path: '/react-viewer' },
            // { id: 'vue-viewer', name: 'Vue Viewer', path: '/vue-viewer' },
            // { id: 'angular-viewer', name: 'Angular Viewer', path: '/angular-viewer' },
            // { id: 'dockerfile-viewer', name: 'Dockerfile Viewer', path: '/dockerfile-viewer' },
            // { id: 'log-viewer', name: 'Log File Viewer', path: '/log-viewer' },
            // { id: 'image-viewer', name: 'Image Viewer', path: '/image-viewer' },
            // { id: 'pdf-viewer', name: 'PDF Viewer', path: '/pdf-viewer' },
            // { id: 'text-viewer', name: 'Text File Viewer', path: '/text-viewer' }
    //     ]
    // },
    {
        id: 'minifiers',
        name: 'Minifiers',
        icon: '🔧',
        isOpen: false,
        subCategories: [
            { id: 'css-minifier', name: 'CSS Minifier', path: '/css-minifier' },
            { id: 'js-minifier', name: 'JS Minifier', path: '/js-minifier' },
            { id: 'html-minifier', name: 'HTML Minifier', path: '/html-minifier' },
        ]
    },
    // {
    //     id: 'color-converters',
    //     name: 'Color Converters',
    //     icon: '🎨',
    //     isOpen: false,
    //     subCategories: [
    //         { id: 'hex-to-rgb', name: 'HEX to RGB Converter', path: '/hex-to-rgb' },
    //         { id: 'rgb-to-hex', name: 'RGB to HEX Converter', path: '/rgb-to-hex' },
    //         { id: 'hsl-to-rgb', name: 'HSL to RGB Converter', path: '/hsl-to-rgb' },
    //         { id: 'rgb-to-hsl', name: 'RGB to HSL Converter', path: '/rgb-to-hsl' },
    //         { id: 'hsv-to-rgb', name: 'HSV to RGB Converter', path: '/hsv-to-rgb' },
    //         { id: 'rgb-to-hsv', name: 'RGB to HSV Converter', path: '/rgb-to-hsv' },
    //         { id: 'cmyk-to-rgb', name: 'CMYK to RGB Converter', path: '/cmyk-to-rgb' },
    //         { id: 'rgb-to-cmyk', name: 'RGB to CMYK Converter', path: '/rgb-to-cmyk' },
    //         { id: 'lab-to-rgb', name: 'LAB to RGB Converter', path: '/lab-to-rgb' },
    //         { id: 'rgb-to-lab', name: 'RGB to LAB Converter', path: '/rgb-to-lab' },
    //         { id: 'xyz-to-rgb', name: 'XYZ to RGB Converter', path: '/xyz-to-rgb' },
    //         { id: 'rgb-to-xyz', name: 'RGB to XYZ Converter', path: '/rgb-to-xyz' },
    //         { id: 'color-palette-generator', name: 'Color Palette Generator', path: '/color-palette-generator' },
    //         { id: 'color-picker', name: 'Color Picker', path: '/color-picker' },
    //         { id: 'gradient-generator', name: 'Gradient Generator', path: '/gradient-generator' },
    //         { id: 'color-blindness-simulator', name: 'Color Blindness Simulator', path: '/color-blindness-simulator' },
    //         { id: 'contrast-checker', name: 'Color Contrast Checker', path: '/contrast-checker' }
    //     ]
    // },
    // {
    //     id: 'unit-converter',
    //     name: 'Unit Converter',
    //     icon: '📏',
    //     isOpen: false,
    //     subCategories: [
    //         { id: 'length-converter', name: 'Length Converter', path: '/length-converter' },
    //         { id: 'weight-converter', name: 'Weight Converter', path: '/weight-converter' },
    //         { id: 'temperature-converter', name: 'Temperature Converter', path: '/temperature-converter' },
    //         { id: 'area-converter', name: 'Area Converter', path: '/area-converter' },
    //         { id: 'volume-converter', name: 'Volume Converter', path: '/volume-converter' },
    //         { id: 'speed-converter', name: 'Speed Converter', path: '/speed-converter' },
    //         { id: 'pressure-converter', name: 'Pressure Converter', path: '/pressure-converter' },
    //         { id: 'energy-converter', name: 'Energy Converter', path: '/energy-converter' },
    //         { id: 'power-converter', name: 'Power Converter', path: '/power-converter' },
    //         { id: 'frequency-converter', name: 'Frequency Converter', path: '/frequency-converter' },
    //         { id: 'time-converter', name: 'Time Converter', path: '/time-converter' },
    //         { id: 'data-storage-converter', name: 'Data Storage Converter', path: '/data-storage-converter' },
    //         { id: 'currency-converter', name: 'Currency Converter', path: '/currency-converter' },
    //         { id: 'angle-converter', name: 'Angle Converter', path: '/angle-converter' },
    //         { id: 'fuel-efficiency-converter', name: 'Fuel Efficiency Converter', path: '/fuel-efficiency-converter' },
    //         { id: 'cooking-converter', name: 'Cooking Unit Converter', path: '/cooking-converter' }
    //     ]
    // },
    // {
    //     id: 'base64-tools',
    //     name: 'Base64 Tools',
    //     icon: '🔢',
    //     isOpen: false,
    //     subCategories: [
    //         { id: 'base64-encode', name: 'Base64 Encode', path: '/base64-encode' },
    //         { id: 'base64-decode', name: 'Base64 Decode', path: '/base64-decode' },
    //         { id: 'base64-image-encoder', name: 'Base64 Image Encoder', path: '/base64-image-encoder' },
    //         { id: 'base64-image-decoder', name: 'Base64 Image Decoder', path: '/base64-image-decoder' },
    //         { id: 'base64-file-encoder', name: 'Base64 File Encoder', path: '/base64-file-encoder' },
    //         { id: 'base64-file-decoder', name: 'Base64 File Decoder', path: '/base64-file-decoder' },
    //         { id: 'base64-url-safe', name: 'Base64 URL Safe Encoder', path: '/base64-url-safe' },
    //         { id: 'base32-encode-decode', name: 'Base32 Encode/Decode', path: '/base32-encode-decode' },
    //         { id: 'base16-encode-decode', name: 'Base16 Encode/Decode', path: '/base16-encode-decode' },
    //         { id: 'base85-encode-decode', name: 'Base85 Encode/Decode', path: '/base85-encode-decode' },
    //         { id: 'base58-encode-decode', name: 'Base58 Encode/Decode', path: '/base58-encode-decode' },
    //         { id: 'data-uri-generator', name: 'Data URI Generator', path: '/data-uri-generator' }
    //     ]
    // },
    {
        id: 'string-utilities',
        name: 'String Utilities',
        icon: '📝',
        isOpen: false,
        subCategories: [
            { id: 'case-converter', name: 'Case Converter', path: '/case-converter' },
            { id: 'reverse-string', name: 'Reverse String', path: '/reverse-string' },
            { id: 'string-length-counter', name: 'String Length Counter', path: '/string-length-counter' },
            { id: 'word-counter', name: 'Word Counter', path: '/word-counter' },
            { id: 'character-counter', name: 'Character Counter', path: '/character-counter' },
            { id: 'remove-duplicates', name: 'Remove Duplicate Lines', path: '/remove-duplicates' },
            { id: 'sort-lines', name: 'Sort Lines', path: '/sort-lines' },
            { id: 'find-replace', name: 'Find & Replace', path: '/find-replace' },
            { id: 'text-diff', name: 'Text Difference Checker', path: '/text-diff' },
            { id: 'string-splitter', name: 'String Splitter', path: '/string-splitter' },
            { id: 'string-joiner', name: 'String Joiner', path: '/string-joiner' },
            { id: 'whitespace-remover', name: 'Whitespace Remover', path: '/whitespace-remover' },
            { id: 'line-numberer', name: 'Line Numberer', path: '/line-numberer' },
            { id: 'text-extractor', name: 'Text Extractor', path: '/text-extractor' },
            { id: 'lorem-ipsum-generator', name: 'Lorem Ipsum Generator', path: '/lorem-ipsum-generator' },
            { id: 'slug-generator', name: 'Slug Generator', path: '/slug-generator' },
            { id: 'camel-case-converter', name: 'CamelCase Converter', path: '/camel-case-converter' },
            { id: 'snake-case-converter', name: 'Snake_case Converter', path: '/snake-case-converter' },
            { id: 'kebab-case-converter', name: 'Kebab-case Converter', path: '/kebab-case-converter' }
        ]
    },
    {
        id: 'escape-unescape',
        name: 'Escape Unescape',
        icon: '🔗',
        isOpen: false,
        subCategories: [
            { id: 'html-escape-unescape', name: 'HTML Escape/Unescape', path: '/html-escape-unescape' },
            { id: 'xml-escape-unescape', name: 'XML Escape/Unescape', path: '/xml-escape-unescape' },
            { id: 'json-escape-unescape', name: 'JSON Escape/Unescape', path: '/json-escape-unescape' },
            { id: 'javascript-escape-unescape', name: 'JavaScript Escape/Unescape', path: '/javascript-escape-unescape' },
            { id: 'sql-escape-unescape', name: 'SQL Escape/Unescape', path: '/sql-escape-unescape' },
            { id: 'regex-escape-unescape', name: 'Regex Escape/Unescape', path: '/regex-escape-unescape' },
            { id: 'url-escape-unescape', name: 'URL Escape/Unescape', path: '/url-escape-unescape' },
            { id: 'unicode-escape-unescape', name: 'Unicode Escape/Unescape', path: '/unicode-escape-unescape' },
            { id: 'c-escape-unescape', name: 'C/C++ Escape/Unescape', path: '/c-escape-unescape' },
            { id: 'java-escape-unescape', name: 'Java Escape/Unescape', path: '/java-escape-unescape' },
            { id: 'python-escape-unescape', name: 'Python Escape/Unescape', path: '/python-escape-unescape' },
            { id: 'php-escape-unescape', name: 'PHP Escape/Unescape', path: '/php-escape-unescape' },
            { id: 'bash-escape-unescape', name: 'Bash Escape/Unescape', path: '/bash-escape-unescape' }
        ]
    },
    {
        id: 'number-utilities',
        name: 'Number Utilities',
        icon: '🔢',
        isOpen: false,
        subCategories: [
            { id: 'number-base-converter', name: 'Number Base Converter', path: '/number-base-converter' },
            { id: 'binary-converter', name: 'Binary Converter', path: '/binary-converter' },
            { id: 'octal-converter', name: 'Octal Converter', path: '/octal-converter' },
            { id: 'hexadecimal-converter', name: 'Hexadecimal Converter', path: '/hexadecimal-converter' },
            { id: 'roman-numeral-converter', name: 'Roman Numeral Converter', path: '/roman-numeral-converter' },
            { id: 'fraction-calculator', name: 'Fraction Calculator', path: '/fraction-calculator' },
            { id: 'percentage-calculator', name: 'Percentage Calculator', path: '/percentage-calculator' },
            { id: 'scientific-calculator', name: 'Scientific Calculator', path: '/scientific-calculator' },
            { id: 'prime-checker', name: 'Prime Number Checker', path: '/prime-checker' },
            { id: 'fibonacci-generator', name: 'Fibonacci Generator', path: '/fibonacci-generator' },
            { id: 'factorial-calculator', name: 'Factorial Calculator', path: '/factorial-calculator' },
            { id: 'gcd-lcm-calculator', name: 'GCD/LCM Calculator', path: '/gcd-lcm-calculator' },
            { id: 'number-formatter', name: 'Number Formatter', path: '/number-formatter' },
            { id: 'random-number-generator', name: 'Random Number Generator', path: '/random-number-generator' },
            { id: 'statistics-calculator', name: 'Statistics Calculator', path: '/statistics-calculator' }
        ]
    },
    // {
    //     id: 'encode-decode',
    //     name: 'Encode & Decode',
    //     icon: '🔤',
    //     isOpen: false,
    //     subCategories: [
    //         { id: 'base64-encode-decode', name: 'Base64 Encode & Decode', path: '/base64-encode-decode' },
    //         { id: 'base32-encode-decode', name: 'Base32 Encode & Decode', path: '/base32-encode-decode' },
    //         { id: 'url-encode-decode', name: 'URL Encode & Decode', path: '/url-encode-decode' },
    //         { id: 'html-encode-decode', name: 'HTML Encode & Decode', path: '/html-encode-decode' },
    //         { id: 'unicode-encode-decode', name: 'Unicode Encode & Decode', path: '/unicode-encode-decode' },
    //         { id: 'hex-encode-decode', name: 'Hex Encode & Decode', path: '/hex-encode-decode' },
    //         { id: 'binary-encode-decode', name: 'Binary Encode & Decode', path: '/binary-encode-decode' },
    //         { id: 'ascii-encode-decode', name: 'ASCII Encode & Decode', path: '/ascii-encode-decode' },
    //         { id: 'morse-code-encode-decode', name: 'Morse Code Encode & Decode', path: '/morse-code-encode-decode' },
    //         { id: 'jwt-encode-decode', name: 'JWT Encode & Decode', path: '/jwt-encode-decode' },
    //         { id: 'json-encode-decode', name: 'JSON Encode & Decode', path: '/json-encode-decode' },
    //         { id: 'xml-encode-decode', name: 'XML Encode & Decode', path: '/xml-encode-decode' },
    //         { id: 'csv-encode-decode', name: 'CSV Encode & Decode', path: '/csv-encode-decode' }
    //     ]
    // },
    {
        id: 'generator',
        name: 'Generator',
        icon: '⚡',
        isOpen: false,
        subCategories: [
            { id: 'password-generator', name: 'Password Generator', path: '/password-generator' },
            { id: 'random-password-generator', name: 'Random Password Generator', path: '/random-password-generator' },
            { id: 'secure-password-generator', name: 'Secure Password Generator', path: '/secure-password-generator' },
            { id: 'api-key-generator', name: 'API Key Generator', path: '/api-key-generator' },
            { id: 'uuid-generator', name: 'UUID Generator', path: '/uuid-generator' },
            { id: 'oauth-token-generator', name: 'OAuth Token Generator', path: '/oauth-token-generator' },
            { id: 'random-string-generator', name: 'Random String Generator', path: '/random-string-generator' },
            { id: 'qr-code-generator', name: 'QR Code Generator', path: '/qr-code-generator' },
            { id: 'barcode-generator', name: 'Barcode Generator', path: '/barcode-generator' },
            { id: 'md5-hash-generator', name: 'MD5 Hash Generator', path: '/md5-hash-generator' },
            { id: 'sha1-hash-generator', name: 'SHA1 Hash Generator', path: '/sha1-hash-generator' },
            { id: 'sha256-hash-generator', name: 'SHA256 Hash Generator', path: '/sha256-hash-generator' },
            { id: 'sha384-hash-generator', name: 'SHA384 Hash Generator', path: '/sha384-hash-generator' },
            { id: 'sha512-hash-generator', name: 'SHA512 Hash Generator', path: '/sha512-hash-generator' },
            { id: 'sha3-hash-generator', name: 'SHA3 Hash Generator', path: '/sha3-hash-generator' },
            { id: 'blake2-hash-generator', name: 'BLAKE2 Hash Generator', path: '/blake2-hash-generator' },
            { id: 'whirlpool-hash-generator', name: 'Whirlpool Hash Generator', path: '/whirlpool-hash-generator' },
            { id: 'ripemd-hash-generator', name: 'RIPEMD Hash Generator', path: '/ripemd-hash-generator' },
            { id: 'bcrypt-hash-generator', name: 'Bcrypt Hash Generator', path: '/bcrypt-hash-generator' },
            { id: 'scrypt-hash-generator', name: 'Scrypt Hash Generator', path: '/scrypt-hash-generator' },
            { id: 'argon2-hash-generator', name: 'Argon2 Hash Generator', path: '/argon2-hash-generator' },
            { id: 'pbkdf2-hash-generator', name: 'PBKDF2 Hash Generator', path: '/pbkdf2-hash-generator' },
            { id: 'rsa-key-generator', name: 'RSA Key Generator', path: '/rsa-key-generator' },
            { id: 'ssh-key-generator', name: 'SSH Key Generator', path: '/ssh-key-generator' }
        ]
    },
    {
        id: 'encrypt-decrypt',
        name: 'Encrypt & Decrypt',
        icon: '🔐',
        isOpen: false,
        subCategories: [
            { id: 'text-encrypt-decrypt', name: 'Text Encrypt & Decrypt', path: '/text-encrypt-decrypt' },
            {id: 'json-encrypt-decrypt', name: 'JSON Encrypt & Decrypt', path: '/json-encrypt-decrypt' },
            { id: 'file-encrypt-decrypt', name: 'File Encrypt & Decrypt', path: '/file-encrypt-decrypt' },
            { id: 'aes-encrypt-decrypt', name: 'AES Encrypt & Decrypt', path: '/aes-encrypt-decrypt' },
            { id: 'des-encrypt-decrypt', name: 'DES Encrypt & Decrypt', path: '/des-encrypt-decrypt' },
            { id: '3des-encrypt-decrypt', name: '3DES Encrypt & Decrypt', path: '/3des-encrypt-decrypt' },
            { id: 'blowfish-encrypt-decrypt', name: 'Blowfish Encrypt & Decrypt', path: '/blowfish-encrypt-decrypt' },
            { id: 'twofish-encrypt-decrypt', name: 'Twofish Encrypt & Decrypt', path: '/twofish-encrypt-decrypt' },
            { id: 'rc4-encrypt-decrypt', name: 'RC4 Encrypt & Decrypt', path: '/rc4-encrypt-decrypt' },
            { id: 'chacha20-encrypt-decrypt', name: 'ChaCha20 Encrypt & Decrypt', path: '/chacha20-encrypt-decrypt' },
            { id: 'rsa-encrypt-decrypt', name: 'RSA Encrypt & Decrypt', path: '/rsa-encrypt-decrypt' },
            { id: 'ecc-encrypt-decrypt', name: 'ECC Encrypt & Decrypt', path: '/ecc-encrypt-decrypt' },
            { id: 'dsa-encrypt-decrypt', name: 'DSA Encrypt & Decrypt', path: '/dsa-encrypt-decrypt' },
            { id: 'elgamal-encrypt-decrypt', name: 'ElGamal Encrypt & Decrypt', path: '/elgamal-encrypt-decrypt' },
            { id: 'zip-encrypt-decrypt', name: 'ZIP Encrypt & Decrypt', path: '/zip-encrypt-decrypt' },
            { id: 'pdf-encrypt-decrypt', name: 'PDF Encrypt & Decrypt', path: '/pdf-encrypt-decrypt' },
            { id: 'image-encrypt-decrypt', name: 'Image Encrypt & Decrypt', path: '/image-encrypt-decrypt' },
            { id: 'database-encrypt-decrypt', name: 'Database Encrypt & Decrypt', path: '/database-encrypt-decrypt' }
        ]
    },
    {
        id: 'cipher',
        name: 'Cipher',
        icon: '🔒',
        isOpen: false,
        subCategories: [
            { id: 'caesar-cipher', name: 'Caesar Cipher', path: '/caesar-cipher' },
            { id: 'vigenere-cipher', name: 'Vigenère Cipher', path: '/vigenere-cipher' },
            { id: 'atbash-cipher', name: 'Atbash Cipher', path: '/atbash-cipher' },
            { id: 'rot13-cipher', name: 'ROT13 Cipher', path: '/rot13-cipher' },
            { id: 'rot47-cipher', name: 'ROT47 Cipher', path: '/rot47-cipher' },
            { id: 'playfair-cipher', name: 'Playfair Cipher', path: '/playfair-cipher' },
            { id: 'hill-cipher', name: 'Hill Cipher', path: '/hill-cipher' },
            { id: 'rail-fence-cipher', name: 'Rail Fence Cipher', path: '/rail-fence-cipher' },
            { id: 'columnar-transposition', name: 'Columnar Transposition', path: '/columnar-transposition' },
            { id: 'affine-cipher', name: 'Affine Cipher', path: '/affine-cipher' },
            { id: 'bacon-cipher', name: 'Bacon Cipher', path: '/bacon-cipher' },
            { id: 'polybius-square', name: 'Polybius Square', path: '/polybius-square' },
            { id: 'four-square-cipher', name: 'Four Square Cipher', path: '/four-square-cipher' },
            { id: 'two-square-cipher', name: 'Two Square Cipher', path: '/two-square-cipher' },
            { id: 'beaufort-cipher', name: 'Beaufort Cipher', path: '/beaufort-cipher' },
            { id: 'gronsfeld-cipher', name: 'Gronsfeld Cipher', path: '/gronsfeld-cipher' },
            { id: 'porta-cipher', name: 'Porta Cipher', path: '/porta-cipher' }
        ]
    },
    {
        id: 'steganography',
        name: 'Steganography',
        icon: '🖼️',
        isOpen: false,
        subCategories: [
            { id: 'image-steganography', name: 'Image Steganography', path: '/image-steganography' },
            { id: 'text-steganography', name: 'Text Steganography', path: '/text-steganography' },
            // { id: 'audio-steganography', name: 'Audio Steganography', path: '/audio-steganography' },
            // { id: 'video-steganography', name: 'Video Steganography', path: '/video-steganography' },
            // { id: 'pdf-steganography', name: 'PDF Steganography', path: '/pdf-steganography' },
            // { id: 'lsb-steganography', name: 'LSB Steganography', path: '/lsb-steganography' },
            // { id: 'dct-steganography', name: 'DCT Steganography', path: '/dct-steganography' },
            // { id: 'whitespace-steganography', name: 'Whitespace Steganography', path: '/whitespace-steganography' },
            // { id: 'unicode-steganography', name: 'Unicode Steganography', path: '/unicode-steganography' },
            // { id: 'metadata-steganography', name: 'Metadata Steganography', path: '/metadata-steganography' }
        ]
    },
    // {
    //     id: 'other-security-tools',
    //     name: 'Other Tools',
    //     icon: '🛠️',
    //     isOpen: false,
    //     subCategories: [
    //         { id: 'password-strength-checker', name: 'Password Strength Checker', path: '/password-strength-checker' },
    //         { id: 'hash-cracker', name: 'Hash Cracker', path: '/hash-cracker' },
    //         { id: 'hash-identifier', name: 'Hash Identifier', path: '/hash-identifier' },
    //         { id: 'digital-signature-verifier', name: 'Digital Signature Verifier', path: '/digital-signature-verifier' },
    //         { id: 'certificate-parser', name: 'Certificate Parser', path: '/certificate-parser' },
    //         { id: 'ssl-checker', name: 'SSL Certificate Checker', path: '/ssl-checker' },
    //         { id: 'checksum-calculator', name: 'Checksum Calculator', path: '/checksum-calculator' },
    //         { id: 'entropy-calculator', name: 'Entropy Calculator', path: '/entropy-calculator' },
    //         { id: 'random-number-generator', name: 'Random Number Generator', path: '/random-number-generator' },
    //         { id: 'secure-delete', name: 'Secure File Delete', path: '/secure-delete' },
    //         { id: 'password-policy-checker', name: 'Password Policy Checker', path: '/password-policy-checker' },
    //         { id: 'breach-checker', name: 'Data Breach Checker', path: '/breach-checker' },
    //         { id: 'network-scanner', name: 'Network Security Scanner', path: '/network-scanner' },
    //         { id: 'vulnerability-scanner', name: 'Vulnerability Scanner', path: '/vulnerability-scanner' },
    //         { id: 'malware-scanner', name: 'Malware Scanner', path: '/malware-scanner' },
    //         { id: 'phishing-detector', name: 'Phishing Detector', path: '/phishing-detector' }
    //     ]
    // }
];

// Helper function to find category and subcategory by IDs
export const findCategoryAndSubcategory = (categoryId?: string, subcategoryId?: string) => {
    const category = categoryId ? categories.find(c => c.id === categoryId) : null;
    let subcategory = null;

    if (category && subcategoryId) {
        subcategory = category.subCategories.find(s => s.id === subcategoryId);
    }

    return { category, subcategory };
};

// For use in React Router config
export const getToolsRoutes = () => {
    const routes = [];

    // Add the base converter route
    routes.push({
        path: '/tools',
        element: lazy(() => import('../pages/frontend/Tools')),
    });

    // Add routes for each category
    categories.forEach(category => {
        routes.push({
            path: `/tools/${category.id}`,
            element: lazy(() => import('../pages/frontend/Tools'))
        });

        // Add routes for each subcategory
        category.subCategories.forEach(subcategory => {
            routes.push({
                path: subcategory.path,
                element: lazy(() => import('../pages/frontend/Tools'))
            });
        });
    });

    return routes;
};

// Export all paths as an array for easy reference
export const getAllPaths = () => {
    const paths: string[] = ['/tools'];

    categories.forEach(category => {
        paths.push(`/tools/${category.id}`);

        category.subCategories.forEach(subcategory => {
            paths.push(subcategory.path);
        });
    });

    return paths;
};